"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDeliveryData = exports.validateDeliveryData = void 0;
const i18next_1 = __importDefault(require("i18next"));
const validateDeliveryData = (deliveryType, fixedDeliveries, conditionalDeliveries, diffDeliveries, customDeliveries) => {
    var _a;
    let validation;
    const errorText = `${i18next_1.default.t('배송비를 입력해주세요')}`;
    if (deliveryType === '1') {
        if (!((_a = fixedDeliveries[0]) === null || _a === void 0 ? void 0 : _a.origin_price))
            validation = errorText;
    }
    if (deliveryType === '4') {
        if (!conditionalDeliveries[0].number || !conditionalDeliveries[0].origin_price)
            validation = errorText;
    }
    if (deliveryType === '3') {
        const testArr = [...diffDeliveries].sort((a, b) => a.number - b.number);
        testArr.forEach((data, index) => {
            if (!(data === null || data === void 0 ? void 0 : data.number) || !(data === null || data === void 0 ? void 0 : data.origin_price)) {
                validation = errorText;
                return false;
            }
            if (index && testArr[index - 1].number === data.number) {
                validation = `${i18next_1.default.t('배송비 구매 개수가 같아요. 다르게 입력해주세요.')}`;
                return false;
            }
        });
    }
    if (deliveryType === '6') {
        customDeliveries.forEach(data => {
            if (!(data === null || data === void 0 ? void 0 : data.name)) {
                validation = `${i18next_1.default.t('배송유형을 입력해주세요')}`;
                return false;
            }
        });
    }
    return validation;
};
exports.validateDeliveryData = validateDeliveryData;
const generateDeliveryData = ({ deliveryType, freeDeliveries, fixedDeliveries, additionalDeliveries, conditionalDeliveries, diffDeliveries, customDeliveries, delete_deliveries, }) => {
    let newDeliveryData;
    let mainDeliveryArr = [];
    if (deliveryType === '2') {
        // ? 무료
        mainDeliveryArr = freeDeliveries;
    }
    else if (deliveryType === '1') {
        // ? 고정
        mainDeliveryArr = fixedDeliveries;
    }
    else if (deliveryType === '4') {
        // ? 조건부
        mainDeliveryArr = conditionalDeliveries;
    }
    else if (deliveryType === '3') {
        // ? 구매개수별 차등배송
        mainDeliveryArr = diffDeliveries;
    }
    else if (deliveryType === '6') {
        // ? 구매자 맞춤 배송
        mainDeliveryArr = customDeliveries;
    }
    if (deliveryType == '6') {
        if (!additionalDeliveries[0].id) {
            newDeliveryData = [...mainDeliveryArr];
        }
        else {
            //? 구매자 맞춤배송 도서산간제주 id값이 있으면 price 0 으로 업데이트 합니당
            additionalDeliveries = [
                {
                    id: additionalDeliveries[0].id,
                    delivery_type: 5,
                    origin_price: 0,
                    delivery_price: 0,
                },
            ];
            newDeliveryData = [...mainDeliveryArr, ...additionalDeliveries];
        }
    }
    else {
        newDeliveryData = [...mainDeliveryArr, ...additionalDeliveries];
    }
    const deliveryDataObj = { deliveries: newDeliveryData };
    if (delete_deliveries.length)
        Object.assign(deliveryDataObj, { delete_deliveries });
    return deliveryDataObj;
};
exports.generateDeliveryData = generateDeliveryData;
